/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { BaseResponse } from '../models/base-response';
import { CompanyAssignedUsersResponse } from '../models/company-assigned-users-response';
import { companyControllerAddLogo } from '../fn/company/company-controller-add-logo';
import { CompanyControllerAddLogo$Params } from '../fn/company/company-controller-add-logo';
import { companyControllerAddUsers } from '../fn/company/company-controller-add-users';
import { CompanyControllerAddUsers$Params } from '../fn/company/company-controller-add-users';
import { companyControllerCreate } from '../fn/company/company-controller-create';
import { CompanyControllerCreate$Params } from '../fn/company/company-controller-create';
import { companyControllerDelete } from '../fn/company/company-controller-delete';
import { CompanyControllerDelete$Params } from '../fn/company/company-controller-delete';
import { companyControllerDeleteImage } from '../fn/company/company-controller-delete-image';
import { CompanyControllerDeleteImage$Params } from '../fn/company/company-controller-delete-image';
import { companyControllerFind } from '../fn/company/company-controller-find';
import { CompanyControllerFind$Params } from '../fn/company/company-controller-find';
import { companyControllerFindOne } from '../fn/company/company-controller-find-one';
import { CompanyControllerFindOne$Params } from '../fn/company/company-controller-find-one';
import { companyControllerForceDelete } from '../fn/company/company-controller-force-delete';
import { CompanyControllerForceDelete$Params } from '../fn/company/company-controller-force-delete';
import { companyControllerGetAllDeleted } from '../fn/company/company-controller-get-all-deleted';
import { CompanyControllerGetAllDeleted$Params } from '../fn/company/company-controller-get-all-deleted';
import { companyControllerGetAssignedUsers } from '../fn/company/company-controller-get-assigned-users';
import { CompanyControllerGetAssignedUsers$Params } from '../fn/company/company-controller-get-assigned-users';
import { companyControllerGetTypes } from '../fn/company/company-controller-get-types';
import { CompanyControllerGetTypes$Params } from '../fn/company/company-controller-get-types';
import { companyControllerRemoveUsers } from '../fn/company/company-controller-remove-users';
import { CompanyControllerRemoveUsers$Params } from '../fn/company/company-controller-remove-users';
import { companyControllerReplaceUsers } from '../fn/company/company-controller-replace-users';
import { CompanyControllerReplaceUsers$Params } from '../fn/company/company-controller-replace-users';
import { companyControllerRestore } from '../fn/company/company-controller-restore';
import { CompanyControllerRestore$Params } from '../fn/company/company-controller-restore';
import { companyControllerUpdate } from '../fn/company/company-controller-update';
import { CompanyControllerUpdate$Params } from '../fn/company/company-controller-update';
import { CompanyItem } from '../models/company-item';
import { CompanyListResponse } from '../models/company-list-response';
import { CompanyTypeResponse } from '../models/company-type-response';
import { EmptyResponse } from '../models/empty-response';
import { MediaItem } from '../models/media-item';

@Injectable({ providedIn: 'root' })
export class CompanyService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `companyControllerFind()` */
  static readonly CompanyControllerFindPath = '/company';

  /**
   * Restituisce l'elenco delle aziende.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `companyControllerFind()` instead.
   *
   * This method doesn't expect any request body.
   */
  companyControllerFind$Response(params?: CompanyControllerFind$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: CompanyListResponse;
}>> {
    const obs = companyControllerFind(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Restituisce l'elenco delle aziende.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `companyControllerFind$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  companyControllerFind(params?: CompanyControllerFind$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: CompanyListResponse;
}> {
    const resp = this.companyControllerFind$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: CompanyListResponse;
}>): BaseResponse & {
'data'?: CompanyListResponse;
} => r.body)
    );
  }

  /** Path part for operation `companyControllerCreate()` */
  static readonly CompanyControllerCreatePath = '/company';

  /**
   * Crea una azienda.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `companyControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  companyControllerCreate$Response(params: CompanyControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: CompanyItem;
}>> {
    const obs = companyControllerCreate(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Crea una azienda.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `companyControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  companyControllerCreate(params: CompanyControllerCreate$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: CompanyItem;
}> {
    const resp = this.companyControllerCreate$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: CompanyItem;
}>): BaseResponse & {
'data'?: CompanyItem;
} => r.body)
    );
  }

  /** Path part for operation `companyControllerGetTypes()` */
  static readonly CompanyControllerGetTypesPath = '/company/types';

  /**
   * Restituisce i tipi di aziende.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `companyControllerGetTypes()` instead.
   *
   * This method doesn't expect any request body.
   */
  companyControllerGetTypes$Response(params?: CompanyControllerGetTypes$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: CompanyTypeResponse;
}>> {
    const obs = companyControllerGetTypes(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Restituisce i tipi di aziende.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `companyControllerGetTypes$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  companyControllerGetTypes(params?: CompanyControllerGetTypes$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: CompanyTypeResponse;
}> {
    const resp = this.companyControllerGetTypes$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: CompanyTypeResponse;
}>): BaseResponse & {
'data'?: CompanyTypeResponse;
} => r.body)
    );
  }

  /** Path part for operation `companyControllerGetAllDeleted()` */
  static readonly CompanyControllerGetAllDeletedPath = '/company/deleted';

  /**
   * Restituisce l'elenco delle aziende eliminate.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `companyControllerGetAllDeleted()` instead.
   *
   * This method doesn't expect any request body.
   */
  companyControllerGetAllDeleted$Response(params?: CompanyControllerGetAllDeleted$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: CompanyListResponse;
}>> {
    const obs = companyControllerGetAllDeleted(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Restituisce l'elenco delle aziende eliminate.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `companyControllerGetAllDeleted$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  companyControllerGetAllDeleted(params?: CompanyControllerGetAllDeleted$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: CompanyListResponse;
}> {
    const resp = this.companyControllerGetAllDeleted$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: CompanyListResponse;
}>): BaseResponse & {
'data'?: CompanyListResponse;
} => r.body)
    );
  }

  /** Path part for operation `companyControllerFindOne()` */
  static readonly CompanyControllerFindOnePath = '/company/{id}';

  /**
   * Restituisce una azienda.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `companyControllerFindOne()` instead.
   *
   * This method doesn't expect any request body.
   */
  companyControllerFindOne$Response(params: CompanyControllerFindOne$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: CompanyItem;
}>> {
    const obs = companyControllerFindOne(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Restituisce una azienda.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `companyControllerFindOne$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  companyControllerFindOne(params: CompanyControllerFindOne$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: CompanyItem;
}> {
    const resp = this.companyControllerFindOne$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: CompanyItem;
}>): BaseResponse & {
'data'?: CompanyItem;
} => r.body)
    );
  }

  /** Path part for operation `companyControllerDelete()` */
  static readonly CompanyControllerDeletePath = '/company/{id}';

  /**
   * Elimina una azienda e la sposta nel cestino.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `companyControllerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  companyControllerDelete$Response(params: CompanyControllerDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: CompanyItem;
}>> {
    const obs = companyControllerDelete(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Elimina una azienda e la sposta nel cestino.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `companyControllerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  companyControllerDelete(params: CompanyControllerDelete$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: CompanyItem;
}> {
    const resp = this.companyControllerDelete$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: CompanyItem;
}>): BaseResponse & {
'data'?: CompanyItem;
} => r.body)
    );
  }

  /** Path part for operation `companyControllerUpdate()` */
  static readonly CompanyControllerUpdatePath = '/company/{id}';

  /**
   * Modifica una azienda.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `companyControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  companyControllerUpdate$Response(params: CompanyControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: CompanyItem;
}>> {
    const obs = companyControllerUpdate(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Modifica una azienda.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `companyControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  companyControllerUpdate(params: CompanyControllerUpdate$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: CompanyItem;
}> {
    const resp = this.companyControllerUpdate$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: CompanyItem;
}>): BaseResponse & {
'data'?: CompanyItem;
} => r.body)
    );
  }

  /** Path part for operation `companyControllerAddUsers()` */
  static readonly CompanyControllerAddUsersPath = '/company/{id}/add-users';

  /**
   * Aggiunge utenti associati ad una azienda.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `companyControllerAddUsers()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  companyControllerAddUsers$Response(params: CompanyControllerAddUsers$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: EmptyResponse;
}>> {
    const obs = companyControllerAddUsers(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Aggiunge utenti associati ad una azienda.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `companyControllerAddUsers$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  companyControllerAddUsers(params: CompanyControllerAddUsers$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: EmptyResponse;
}> {
    const resp = this.companyControllerAddUsers$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: EmptyResponse;
}>): BaseResponse & {
'data'?: EmptyResponse;
} => r.body)
    );
  }

  /** Path part for operation `companyControllerReplaceUsers()` */
  static readonly CompanyControllerReplaceUsersPath = '/company/{id}/replace-users';

  /**
   * Sostituisce gli utenti associati ad una azienda.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `companyControllerReplaceUsers()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  companyControllerReplaceUsers$Response(params: CompanyControllerReplaceUsers$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: EmptyResponse;
}>> {
    const obs = companyControllerReplaceUsers(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Sostituisce gli utenti associati ad una azienda.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `companyControllerReplaceUsers$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  companyControllerReplaceUsers(params: CompanyControllerReplaceUsers$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: EmptyResponse;
}> {
    const resp = this.companyControllerReplaceUsers$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: EmptyResponse;
}>): BaseResponse & {
'data'?: EmptyResponse;
} => r.body)
    );
  }

  /** Path part for operation `companyControllerRemoveUsers()` */
  static readonly CompanyControllerRemoveUsersPath = '/company/{id}/remove-users';

  /**
   * Rimuove gli utenti associati ad una azienda.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `companyControllerRemoveUsers()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  companyControllerRemoveUsers$Response(params: CompanyControllerRemoveUsers$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: EmptyResponse;
}>> {
    const obs = companyControllerRemoveUsers(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Rimuove gli utenti associati ad una azienda.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `companyControllerRemoveUsers$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  companyControllerRemoveUsers(params: CompanyControllerRemoveUsers$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: EmptyResponse;
}> {
    const resp = this.companyControllerRemoveUsers$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: EmptyResponse;
}>): BaseResponse & {
'data'?: EmptyResponse;
} => r.body)
    );
  }

  /** Path part for operation `companyControllerGetAssignedUsers()` */
  static readonly CompanyControllerGetAssignedUsersPath = '/company/{id}/users';

  /**
   * Restituisce gli utenti associati ad una azienda.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `companyControllerGetAssignedUsers()` instead.
   *
   * This method doesn't expect any request body.
   */
  companyControllerGetAssignedUsers$Response(params: CompanyControllerGetAssignedUsers$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: CompanyAssignedUsersResponse;
}>> {
    const obs = companyControllerGetAssignedUsers(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Restituisce gli utenti associati ad una azienda.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `companyControllerGetAssignedUsers$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  companyControllerGetAssignedUsers(params: CompanyControllerGetAssignedUsers$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: CompanyAssignedUsersResponse;
}> {
    const resp = this.companyControllerGetAssignedUsers$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: CompanyAssignedUsersResponse;
}>): BaseResponse & {
'data'?: CompanyAssignedUsersResponse;
} => r.body)
    );
  }

  /** Path part for operation `companyControllerRestore()` */
  static readonly CompanyControllerRestorePath = '/company/{id}/restore';

  /**
   * Ripristina una azienda dal cestino.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `companyControllerRestore()` instead.
   *
   * This method doesn't expect any request body.
   */
  companyControllerRestore$Response(params: CompanyControllerRestore$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: CompanyItem;
}>> {
    const obs = companyControllerRestore(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Ripristina una azienda dal cestino.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `companyControllerRestore$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  companyControllerRestore(params: CompanyControllerRestore$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: CompanyItem;
}> {
    const resp = this.companyControllerRestore$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: CompanyItem;
}>): BaseResponse & {
'data'?: CompanyItem;
} => r.body)
    );
  }

  /** Path part for operation `companyControllerForceDelete()` */
  static readonly CompanyControllerForceDeletePath = '/company/{id}/delete';

  /**
   * Elimina una azienda permanentemente.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `companyControllerForceDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  companyControllerForceDelete$Response(params: CompanyControllerForceDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: CompanyItem;
}>> {
    const obs = companyControllerForceDelete(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Elimina una azienda permanentemente.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `companyControllerForceDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  companyControllerForceDelete(params: CompanyControllerForceDelete$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: CompanyItem;
}> {
    const resp = this.companyControllerForceDelete$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: CompanyItem;
}>): BaseResponse & {
'data'?: CompanyItem;
} => r.body)
    );
  }

  /** Path part for operation `companyControllerAddLogo()` */
  static readonly CompanyControllerAddLogoPath = '/company/{id}/logo';

  /**
   * Carica il logo di una azienda.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `companyControllerAddLogo()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  companyControllerAddLogo$Response(params: CompanyControllerAddLogo$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: CompanyItem;
}>> {
    const obs = companyControllerAddLogo(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Carica il logo di una azienda.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `companyControllerAddLogo$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  companyControllerAddLogo(params: CompanyControllerAddLogo$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: CompanyItem;
}> {
    const resp = this.companyControllerAddLogo$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: CompanyItem;
}>): BaseResponse & {
'data'?: CompanyItem;
} => r.body)
    );
  }

  /** Path part for operation `companyControllerDeleteImage()` */
  static readonly CompanyControllerDeleteImagePath = '/company/{id}/logo';

  /**
   * Elimina il logo della azienda.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `companyControllerDeleteImage()` instead.
   *
   * This method doesn't expect any request body.
   */
  companyControllerDeleteImage$Response(params: CompanyControllerDeleteImage$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: MediaItem;
}>> {
    const obs = companyControllerDeleteImage(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Elimina il logo della azienda.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `companyControllerDeleteImage$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  companyControllerDeleteImage(params: CompanyControllerDeleteImage$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: MediaItem;
}> {
    const resp = this.companyControllerDeleteImage$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: MediaItem;
}>): BaseResponse & {
'data'?: MediaItem;
} => r.body)
    );
  }

}
